import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ad36e9f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "gauge-label"
}
const _hoisted_2 = ["width", "height", "aria-label"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "8",
  width: "80",
  height: "60",
  fill: "none",
  stroke: "rgba(224,224,224,0.08)",
  "stroke-width": "1"
}, null, -1))
const _hoisted_4 = ["d"]
const _hoisted_5 = ["d"]
const _hoisted_6 = ["d", "stroke"]
const _hoisted_7 = ["x1", "y1", "x2", "y2", "stroke", "stroke-width"]
const _hoisted_8 = ["x1", "y1", "x2", "y2", "stroke"]
const _hoisted_9 = ["cx", "cy", "fill"]
const _hoisted_10 = ["cx", "cy"]
const _hoisted_11 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "gauge",
    style: _normalizeStyle({ '--stroke': _ctx.stroke })
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock("svg", {
      width: _ctx.size,
      height: _ctx.size * 0.78,
      viewBox: "0 0 100 78",
      class: "gauge-svg",
      role: "img",
      "aria-label": _ctx.ariaLabel
    }, [
      _hoisted_3,
      _createElementVNode("path", {
        d: _ctx.bgArc,
        fill: "none",
        stroke: "rgba(255,255,255,0.06)",
        "stroke-width": "6",
        "stroke-linecap": "square"
      }, null, 8, _hoisted_4),
      (_ctx.thresholdArc)
        ? (_openBlock(), _createElementBlock("path", {
            key: 0,
            d: _ctx.thresholdArc,
            fill: "none",
            stroke: "rgba(255,0,0,0.12)",
            "stroke-width": "6",
            "stroke-linecap": "square"
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("path", {
        d: _ctx.valueArc,
        fill: "none",
        stroke: _ctx.stroke,
        "stroke-width": "4",
        "stroke-linecap": "square",
        class: "gauge-value"
      }, null, 8, _hoisted_6),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticks, (t, i) => {
        return (_openBlock(), _createElementBlock("line", {
          key: i,
          x1: t.inner.x,
          y1: t.inner.y,
          x2: t.outer.x,
          y2: t.outer.y,
          stroke: t.major ? 'rgba(255,255,255,0.34)' : 'rgba(255,255,255,0.16)',
          "stroke-width": t.major ? 1 : 0.6
        }, null, 8, _hoisted_7))
      }), 128)),
      _createElementVNode("line", {
        x1: _ctx.cx,
        y1: _ctx.cy,
        x2: _ctx.needle.x,
        y2: _ctx.needle.y,
        stroke: _ctx.stroke,
        "stroke-width": "1.25",
        "stroke-linecap": "square",
        class: "gauge-needle"
      }, null, 8, _hoisted_8),
      _createElementVNode("circle", {
        cx: _ctx.cx,
        cy: _ctx.cy,
        r: "2",
        fill: _ctx.stroke
      }, null, 8, _hoisted_9),
      _createElementVNode("circle", {
        cx: _ctx.cx,
        cy: _ctx.cy,
        r: "0.8",
        fill: "#000"
      }, null, 8, _hoisted_10),
      _createElementVNode("text", {
        x: "50",
        y: "74",
        "text-anchor": "middle",
        class: "gauge-readout",
        fill: _ctx.stroke
      }, _toDisplayString(_ctx.display) + _toDisplayString(_ctx.unit), 9, _hoisted_11)
    ], 8, _hoisted_2))
  ], 4))
}